import { border, color, rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
      position: relative;
    }

    :host([disabled]) {
      :where(.trigger) {
        background: ${color('neutral', 100)};
        border: ${border(1, 'neutral', 300)};
        color: ${color('neutral', 400)};
        cursor: not-allowed;
      }
    }

    :where(.content) {
      background: ${color('white')};
      border: ${border(1, 'grey', 300)};
      border-radius: ${rem(4)};
      box-shadow: 0 ${rem(2, 8)} hsl(240 3.8% 46.1% / 0.12);
      margin: unset;
      min-inline-size: var(--reference-width, 0);
      overflow: inherit;
      padding: unset;
    }

    :where(.trigger) {
      display: block;
    }
  `,
];
